import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { ComposeViewState } from 'owa-mail-compose-store';
import ImportanceType from 'owa-service/lib/contract/ImportanceType';
import datapoints from '../datapoints';

export default createLegacyActionWithDatapoint(
    'setImportance',
    datapoints.ComposeCommandSetImportance
)(function setImportance(viewState: ComposeViewState, importance: ImportanceType) {
    viewState.importance = importance;
});
